<template lang="pug">
#filtrar-inteligencia-territorial
    .div
        .filtrar-inteligencia-territorial__button
            el-popover(placement='bottom', width='600', trigger='click', popper-class='el-popover-inteligencia-territorial')
                BaseButton.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) {{ $t('mensagens.inteligenciaTerritorial.filtrosAvancados') }}

                el-form.filtro(label-position='top', v-loading='isLoading')
                    .filtrar-inteligencia-territorial-popover-header
                        .filtrar-inteligencia-territorial-popover-header__text {{ $t('mensagens.inteligenciaTerritorial.filtrosAvancados') }}
                        .filtrar-inteligencia-territorial-popover-header__link(
                            @click='aplicar'
                        )
                            | {{ $t('mensagens.inteligenciaTerritorial.aplicarFiltro') }}

                    .filtrar-inteligencia-territorial-popover-collapse
                        el-form-item.mb-0.filtro-accordion
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(
                                    :title="$t('mensagens.inteligenciaTerritorial.ufMunicipio')",
                                    name='estados'
                                )
                                    .filtrar-inteligencia-territorial-popover-collapse__select(
                                        v-loading='!estados.length'
                                    )
                                        div
                                            el-select(
                                                v-model='estadoSelecionado',
                                                filterable,
                                                value-key='id',
                                                @change='buscarMunicipios()',
                                                :placeholder="$t('mensagens.inteligenciaTerritorial.selecioneAUf')"
                                            )
                                                el-option(
                                                    v-for='(estado, index) in estados',
                                                    :key='index',
                                                    :label='estado.nome',
                                                    :value='estado'
                                                ) {{ estado.nome }}
                                        div
                                            el-select(
                                                v-model='municipioSelecionado',
                                                filterable,
                                                value-key='id',
                                                :placeholder="$t('mensagens.inteligenciaTerritorial.selecioneOMunicipio')"
                                            )
                                                el-option(
                                                    v-for='(municipio, index) in municipios',
                                                    :key='index',
                                                    :label='municipio.nome',
                                                    :value='municipio'
                                                ) {{ municipio.nome }}

                                el-collapse-item(
                                    :title="$t('mensagens.inteligenciaTerritorial.cicloAno')",
                                    name='cicloAno'
                                )
                                    div
                                        el-select(
                                            v-model='safraSelecionada',
                                            filterable,
                                            disabled,
                                            value-key='id',
                                            :placeholder="$t('mensagens.inteligenciaTerritorial.safra')"
                                        )
                                            el-option(
                                                v-for='(safra, index) in safras',
                                                :key='index',
                                                :label='safra.nome',
                                                :value='safra'
                                            ) {{ safras.nome }}

                                el-collapse-item(
                                    :title="$t('mensagens.inteligenciaTerritorial.areaDoImovel')",
                                    name='areaImovel'
                                )
                                    el-radio-group(
                                        v-model='areaImovelSelecionadas'
                                    )
                                        el-radio(
                                            v-model='areaImovel',
                                            label='MENOR_50_HA'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.menorQueCinquenta') }}
                                        el-radio(
                                            v-model='areaImovel',
                                            label='ENTRE_50_E_1000_HA'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.deCinquentaAMil') }}
                                        el-radio(
                                            v-model='areaImovel',
                                            label='MAIOR_QUE_1000_HA'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.maiorQueMil') }}

                                el-collapse-item(
                                    :title="$t('mensagens.inteligenciaTerritorial.areaPlantada')",
                                    name='areaPlantada'
                                )
                                    el-radio-group(
                                        v-model='areaPlantadaSelecionadas'
                                    )
                                        el-radio(
                                            v-model='areaPlantada',
                                            label='MENOR_50_HA'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.menorQueCinquenta') }}
                                        el-radio(
                                            v-model='areaPlantada',
                                            label='ENTRE_50_E_1000_HA'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.deCinquentaAMil') }}
                                        el-radio(
                                            v-model='areaPlantada',
                                            label='MAIOR_QUE_1000_HA'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.maiorQueMil') }}

                                el-collapse-item(
                                    :title="$t('mensagens.inteligenciaTerritorial.areaDePastagem')",
                                    name='areaPastagem'
                                )
                                    el-radio-group(
                                        v-model='areaPastagemSelecionadas'
                                    )
                                        el-radio(
                                            v-model='areaPastagem',
                                            label='DEGRADACAO_AUSENTE'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.degradacaoAusente') }}
                                        el-radio(
                                            v-model='areaPastagem',
                                            label='DEGRADACAO_INTERMEDIARIA'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.degradacaoIntermediaria') }}
                                        el-radio(
                                            v-model='areaPastagem',
                                            label='DEGRADACAO_SEVERA'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.degradacaoSevera') }}

                                el-collapse-item(
                                    :title="$t('mensagens.inteligenciaTerritorial.restricaoSocioambiental')",
                                    name='restricaoSocioambiental'
                                )
                                    el-radio-group(
                                        v-model='restricaoSocioambientalSelecionadas'
                                    )
                                        el-radio(
                                            label='POSSUI_RESTRICOES'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.possuiRestricoes') }}
                                        el-radio(
                                            label='NAO_POSSUI_RESTRICOES'
                                        ) {{ $t('mensagens.inteligenciaTerritorial.naoPossuiRestricoes') }}
</template>

<script>
import { mapActions, mapState } from 'vuex';

import LocalidadeService from '@/services/LocalidadeService';

import EventBus from '@/utils/eventBus';

import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'FiltroAvancadoInteligenciaTerritorial',
    components: {
        BaseButton
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            collapseFiltroAvancado: [''],
            safras: [],
            safraSelecionada: [],
            estados: [],
            estadoSelecionado: {},
            municipios: [],
            municipioSelecionado: {},
            acaoCollapse: {
                estados: {
                    collapse: 'estados',
                    callback: 'buscarEstados'
                }
            },
            areaImovel: '',
            areaPlantada: '',
            areaPastagem: '',
            areaImovelSelecionadas: null,
            areaPlantadaSelecionadas: null,
            areaPastagemSelecionadas: null,
            restricaoSocioambientalSelecionadas: null
        };
    },
    created() {
        EventBus.$off('filtroAvancadoInteligenciaTerritorial:atualizar-lista-municipios');
        EventBus.$on('filtroAvancadoInteligenciaTerritorial:atualizar-lista-municipios', (municipios) => {
            this.municipios = municipios;
        });
    },
    computed: {
        ...mapState({
            filtroState: state => state.filtroInteligenciaTerritorial
        })
    },
    watch: {
        filtroState: {
            deep: true,
            immediate: false,
            async handler(newValue) {
                if (newValue && Object.keys(newValue).length > 0) {
                    if (newValue?.possuiRestricao === null) {
                        this.restricaoSocioambientalSelecionadas = null;
                    }
                    if (!newValue.areaImovelInicial) {
                        this.areaImovelSelecionadas = null;
                    }
                    if (!newValue.areaPlantadaInicial) {
                        this.areaPlantadaSelecionadas = null;
                    }
                    if (!newValue.areaPastagemInicial) {
                        this.areaPastagemSelecionadas = null;
                    }
                    if (newValue.tipoAgrupamento === 'PAIS') {
                        this.estadoSelecionado = {};
                        this.municipioSelecionado = {};
                    }
                    if (newValue.tipoAgrupamento === 'ESTADO') {
                        this.estadoSelecionado = newValue?.objEstado || {};
                    } else if (newValue.tipoAgrupamento === 'MUNICIPIO') {
                        this.estadoSelecionado = newValue?.objEstado || {};
                        this.municipioSelecionado = newValue?.objMunicipio || {};
                    }
                }
            }
        }
    },
    methods: {
        ...mapActions(['setFiltroInteligenciaTerritorial', 'setArrayTodosMunicipiosEstadoInteligenciaTerritorial']),
        aplicar() {
            let filtros = {};
            let filtrosEstadoMunicipio = {};
            let filtroFinal = {};

            if (this.restricaoSocioambientalSelecionadas) {
                if (this.restricaoSocioambientalSelecionadas.length > 0) {
                    filtros.possuiRestricao = this.restricaoSocioambientalSelecionadas === 'POSSUI_RESTRICOES';
                }
            }
            if (this.areaImovelSelecionadas) {
                if (this.areaImovelSelecionadas.length > 0) {
                    filtros.areaImovelInicial = this.areaImovelSelecionadas;
                }
            }
            if (this.areaPlantadaSelecionadas) {
                if (this.areaPlantadaSelecionadas.length > 0) {
                    filtros.areaPlantadaInicial = this.areaPlantadaSelecionadas;
                }
            }
            if (this.areaPastagemSelecionadas) {
                if (this.areaPastagemSelecionadas.length > 0) {
                    filtros.areaPastagemInicial = this.areaPastagemSelecionadas;
                }
            }
            if (this.estadoSelecionado && this.estadoSelecionado?.id) {
                filtrosEstadoMunicipio = {
                    tipoAgrupamento: 'ESTADO',
                    estadoId: this.estadoSelecionado?.id,
                    siglaEstado: this.estadoSelecionado?.sigla,
                    objEstado: this.estadoSelecionado,
                    idsMunicipios: []
                };
            }
            if (this.municipioSelecionado && this.municipioSelecionado?.id) {
                filtrosEstadoMunicipio = {
                    estadoId: this.estadoSelecionado?.id,
                    tipoAgrupamento: 'MUNICIPIO',
                    idsMunicipios: [this.municipioSelecionado?.id],
                    nome: this.municipioSelecionado?.nome + '-' + this.estadoSelecionado?.sigla,
                    siglaEstado: this.estadoSelecionado?.sigla,
                    objEstado: this.estadoSelecionado,
                    municipioSelecionado: { id: this.municipioSelecionado?.id, nome: this.municipioSelecionado?.nome }
                };
            }
            filtroFinal = {
                ...this.filtroState,
                ...filtrosEstadoMunicipio,
                ...filtros
            };
            this.setFiltroInteligenciaTerritorial(filtroFinal);
        },
        abrirCollapse(ref) {
            if (ref && ref === 'estados') {
                try {
                    if (this.acaoCollapse) {
                        const acao = this.acaoCollapse[ref];
                        if (!this[ref].length) {
                            this[acao.callback]();
                        }
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados.'
                    );
                    throw new Error(
                        'Ação não registrada para o collapse:' +
                        ref +
                        ', ERRRO:' +
                        error
                    );
                }
            }
        },
        buscarEstados() {
            LocalidadeService.findNivel1(1)
                .then(({ data }) => {
                    setTimeout(() => {
                        this.estados = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de estados.'
                    );
                    throw error;
                });
        },
        async buscarMunicipios() {
            await LocalidadeService.findNivel2(this.estadoSelecionado?.id, false)
                .then(({ data }) => {
                    this.municipioSelecionado = null;
                    this.municipios = data;
                    this.setArrayTodosMunicipiosEstadoInteligenciaTerritorial(data);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de municipio.'
                    );
                    throw error;
                });
        },
        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.filtrar-inteligencia-territorial-container {
    display: flex;
    justify-content: space-between;
}

.filtrar-inteligencia-territorial-input-container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.filtrar-inteligencia-territorial__resultado {
    position: absolute;
    width: 100%;
}

.filtrar-inteligencia-territorial__resultado__nome {
    margin: 0px 10px;
}

.filtrar-inteligencia-territorial__input {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.filtrar-inteligencia-territorial__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.filtrar-inteligencia-territorial__categoria {
    font-weight: bold;
}

.filtrar-inteligencia-territorial-filtro-selecionado {
    margin-top: 15px;
    min-height: 42px;
}

.filtrar-inteligencia-territorial-filtro-selecionado__titulo {
    font-size: 18px;
    font-weight: 100;
}

.filtrar-inteligencia-territorial-filtro-selecionado__tag {
    margin: 0px 5px 10px 5px;
}

.filtrar-inteligencia-territorial-filtro-selecionado__limpar {
    margin: 0px 5px 10px 5px;

    i {
        padding-left: 5px;
    }
}

.filtrar-inteligencia-territorial-filtro-selecionado__nenhum {
    margin-left: 5px;
    font-weight: 100;
    font-style: italic;
    font-size: 14px;
}

.filtrar-inteligencia-territorial-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtrar-inteligencia-territorial-popover-header__text {
        color: var(--primary);
        font-weight: 600;
        font-size: 16px;
        line-height: 14px;
    }

    .filtrar-inteligencia-territorial-popover-header__link {
        color: #1989fa;
        font-weight: 500;
        text-decoration: underline;
        cursor: pointer;
        font-size: 16px;
        line-height: 14px;
    }
}

.filtrar-inteligencia-territorial-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 160px;
        line-height: 2;
    }

    .el-checkbox-group,
    .el-radio-group {
        display: flex;
        flex-wrap: wrap;
    }

    .el-radio {
        color: var(--primary);
        font-weight: 500;
        line-height: 16px;
    }
}

.filtrar-inteligencia-territorial-popover-collapse__select {
    display: flex;
    justify-content: flex-start;
    gap: 25px;
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    display: flex;
    align-items: center;

    .lyra-filtro:before {
        content: '';
        width: 15px !important;
        height: 12px !important;
        background-color: var(--primary) !important;
        margin-right: 6px;
    }
}

.el-collapse-item__categorias--loading {
    min-height: 76px;
}

.el-tag {
    border-radius: 20px !important;
}

.el-tag.el-tag--success {
    border-color: var(--secondary-two) !important;
    color: var(--white) !important;
    background: var(--secondary-two) !important;
}

span.filtrar-inteligencia-territorial-filtro-selecionado__limpar.el-tag.el-tag--info.el-tag--light {
    cursor: pointer;
}
</style>

<style lang="scss">
.el-popover-inteligencia-territorial {
    font-family: 'Roboto', 'sans serif' !important;
    padding: 20px !important;

    .el-collapse-item__header {
        color: #3B3B3B;
        font-weight: 500;
        font-size: 14px;

        .el-collapse-item__arrow {
            font-weight: 600;
        }
    }
}
</style>
